module.exports = __webpack_public_path__ + "static/img/solution_case4.e44656d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/solution_case4.png
// module id = dXRr
// module chunks = 34